import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export type ShowInterestDialogProps = {
    open: boolean;
    onConfirm: () => void;
    onCancel: () => void;
};

// Confirmation step for the "Show interest" option, which sends the request
// without an accompanying message.
export function ShowInterestDialog({ open, onConfirm, onCancel }: ShowInterestDialogProps): ReactElement {
    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={onCancel}
            aria-labelledby="show-interest-dialog-title"
            aria-describedby="show-interest-dialog-description">
            <DialogTitle id="show-interest-dialog-title">{t('OFFER_REQUESTS.CONTACT.DIALOG.TITLE')}</DialogTitle>
            <DialogContent>
                <DialogContentText id="show-interest-dialog-description">
                    {t('OFFER_REQUESTS.CONTACT.DIALOG.BODY')}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel}>{t('OFFER_REQUESTS.CONTACT.DIALOG.CANCEL')}</Button>
                <Button variant="contained" onClick={onConfirm}>
                    {t('OFFER_REQUESTS.CONTACT.DIALOG.CONFIRM')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
